<template>
  <v-container fluid>
    <v-row class="pb-0" dense v-for="(breakTimes, idx) in breaks" :key="breakTimes.id">
      <v-col :cols="2">
        <div>Break: {{ idx + 1 }}</div>
      </v-col>
      <v-col :cols="4">
        <TimePickerField
          v-model="breakTimes.startTime"
          label="Break Start"
          :min="startTime"
          :max="breakTimes.endTime"
          :rules="startRules"
          v-on:input="update"/>
      </v-col>
      <v-col :cols="4">
        <TimePickerField
          v-model="breakTimes.endTime"
          label="Break End"
          ref="endTimeField"
          :min="breakTimes.startTime"
          :rules="getEndRules(breakTimes)"
          v-on:input="update"/>
      </v-col>
      <v-col :cols="2">
        <v-btn icon @click="removeBreak(breakTimes.id)"><v-icon>close</v-icon></v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TimePickerField from '@/components/time/TimePickerField.vue';
import isEqual from 'date-fns/isEqual';
import isAfter from 'date-fns/isAfter';
import DateTimeUtil from '../../util/date-time-util';

export default {
  name: 'BreaksAssignment',

  props: {
    value: Array,
    startTime: String,
    startTimeRules: Array,
    endTimeRules: Array,
  },

  components: {
    TimePickerField,
  },

  data() {
    return {
      breaks: this.value,
      startRules: this.startTimeRules,
      endRules: this.endTimeRules,
    };
  },

  methods: {
    update() {
      this.$emit('input', this.breaks);
    },

    removeBreak(id) {
      this.$emit('remove', id);
    },

    getEndRules(breakTimes) {
      return [(endTime) => {
        const start = DateTimeUtil.getHours(breakTimes.startTime);
        const end = DateTimeUtil.getHours(endTime);
        return !!endTime || isEqual(start, end) || isAfter(end, start) || 'End time must be after start time';
      }];
    },
  },
};
</script>

<style scoped>

</style>
